import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
  'GET_FILTER_OPTIONS',
  'SET_FILTER',
  'SET_APPLIED_FILTER',
  'SET_USER_APPLIED_FILTER'
);
